module.exports = __webpack_public_path__ + "6392fb42851e3d55586159f38c1a1b33.png";